/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Empty_TitleInputs */

const es_settings_files_empty_title = /** @type {(inputs: Settings_Files_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron archivos`)
};

const en_settings_files_empty_title = /** @type {(inputs: Settings_Files_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files found`)
};

/**
* | output |
* | --- |
* | "No files found" |
*
* @param {Settings_Files_Empty_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_empty_title = /** @type {((inputs?: Settings_Files_Empty_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Empty_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_empty_title(inputs)
	return en_settings_files_empty_title(inputs)
});
export { settings_files_empty_title as "settings.files.empty.title" }